<template>
  <el-main>
    <el-form class="el-form-search" label-width="110px">
      <el-form-item label="礼包名称：">
        <el-input size="small" v-model="name" placeholder="请输入礼包名称"></el-input>
      </el-form-item>
      <el-form-item label=" " label-width="21px">
        <el-button size="small" type="primary" @click="getCouponList()">搜索</el-button>
        <el-button size="small" type="text" @click="clearSearch">清空搜索条件</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" :header-cell-style="{ 'background-color': '#f8f9fa' }">
      <template slot="empty">
        <No />
      </template>
      <el-table-column label="礼包名称" align="center">
        <template v-slot="{ row }">
          {{ row.gift.name }}
        </template>
      </el-table-column>
      <el-table-column label="礼包内容" align="center">
        <template v-slot="{ row }">
          {{ row.gift.remark }}
        </template>
      </el-table-column>
      <el-table-column label="领取时间" align="center">
        <template v-slot="{ row }">
          {{ getDateformat(row.create_time) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="{ row }">
          <el-tooltip effect="light" content="查看" placement="top-start">
            <el-button v-if="row.coupon" @click="lookGiftInfo(row)" type="primary" icon="el-icon-view" circle size="mini"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Paging class="paging" :total="total" :page="page" :pageNum="pageNum" @updatePageNum="updateData"></Paging>

    <el-dialog title="优惠券" :visible.sync="show_coupon_info">
      <el-form :model="now_show_data" label-width="150px">
        <el-form-item label="优惠券名称">
          {{ now_show_data.coupon.name }}
        </el-form-item>
        <el-form-item label="优惠券金额">
          <el-button type="text"> {{ now_show_data.coupon.price }}</el-button>
        </el-form-item>
        <el-form-item label="优惠券规则">
            <pre> {{ now_show_data.coupon.details }} </pre>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import Paging from '@/components/paging.vue';
import { getDateformat } from '@/util/getDate';
export default {
  components: {
    Paging,
  },
  data() {
    return {
      name: '',
      page: 1,
      pageNum: 10,
      total: 0,
      list: [],
      status: '3',
      type: '4',
      now_show_data:{
        coupon:{}
      },
      show_coupon_info:false
    };
  },
  created() {
    this.getCouponList();
  },
  methods: {
    lookGiftInfo(data){
        this.now_show_data = data
        this.show_coupon_info = true
    },
    clearSearch() {
      this.name = '';
      this.status = '3';
      this.type = '4';
      this.getCouponList();
    },
    updateData(val, status) {
      if (status == 0) {
        this.pageNum = val;
        this.getCouponList();
      } else {
        this.page = val;
        this.getCouponList();
      }
    },
    getDateformat(val) {
      return getDateformat(val);
    },
    getCouponList() {
      let data = {
        page: this.page,
        rows: this.pageNum,
        name: this.name,
      };
      if (this.status != 3) data.status = this.status;
      if (this.type != 4) data.type = this.type;
      this.$axios.post(this.$api.push.couponList, data).then((res) => {
        if (res.code == 0) {
          let list = res.result.list;
          this.total = res.result.total_number;
          this.list = list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
}
</style>
